(function () {
	'use strict';

	angular.module('app.setup')
		.service('dataPipelineService', dataPipelineService);

	dataPipelineService.$inject = ['$rootScope', '$http', '$filter','storeService'];

	function dataPipelineService($rootScope, $http, $filter, storeService) {
		var service = {
			getDownloadDataPath: getDownloadDataPath,
			getRestorePathFromDownloadPath: getRestorePathFromDownloadPath,
			getStatusPathFromDownloadPath: getStatusPathFromDownloadPath,
			getPullPathFromDownloadPath: getPullPathFromDownloadPath,
			getAwsLogsUrl: getAwsLogsUrl,
			getAwsLogsCli: getAwsLogsCli,
			getAwsLogsGroup: getAwsLogsGroup,
			getSfnExecutionUrl: getSfnExecutionUrl,
			getSfnExecutionCli: getSfnExecutionCli,
			getInsightLogsUrl: getInsightLogsUrl,
			rerun: rerun,
			markFailed: markFailed
		};
		return service;

		function getDownloadDataPath(dataType, factoryNdx, jobId, logUrl, dateRequest, dateEnd, hasS3Path, hasS3GlobalFilePath, postProcessed) {
			if (dataType === 'leandna connect') {
				return '/api/2/factndx/' + factoryNdx + '/WorkerData?path=' + encodeURIComponent(logUrl) + '&dataType=leandnaconnect';
			} else {
				var requestTimestamp = dateRequest;
				if (dataType === 'leanload') {
					requestTimestamp = dateEnd;
				}

				var downloadUrl = '/api/2/factndx/' + factoryNdx + '/WorkerData?';
				var hasS3Path = hasS3Path === 'true';
				var hasS3GlobalFilePath = hasS3GlobalFilePath === 'true';
				if ((dataType !== 'global' && hasS3Path)
					|| (dataType === 'global' && hasS3GlobalFilePath)
				) {
					downloadUrl += 'jobId=' + jobId;
				} else {
					downloadUrl += 'requestTimestamp=' + requestTimestamp;
				}

				if (dataType != null) {
					downloadUrl += '&dataType=' + dataType;
				}

				if (postProcessed) {
					downloadUrl += '&postProcessed=true';
				}
				return downloadUrl;
			}
		}

		function getRestorePathFromDownloadPath(href) {
			var thawHref = href.split('?');
			thawHref[0] += '/Thaw';
			return thawHref.join('?');
		}

		function getStatusPathFromDownloadPath(href) {
			var thawHref = href.split('?');
			thawHref[0] += '/Status';
			return thawHref.join('?');
		}

		function getPullPathFromDownloadPath(href) {
			var thawHref = href.split('?');
			thawHref[0] += '/Pull';
			return thawHref.join('?');
		}

		function rerun(factoryNdx, jobId, tablesToClear, approver) {
			var rerunUrl = '/api/2/factndx/' + factoryNdx + '/WorkerQueue/Job/Rerun';
			var content = {
				'tablesToClear': tablesToClear,
				'approver': approver,
				'jobId': jobId
			};
			return $http.put(rerunUrl, content)
				.then(function () {
					return '';
				})
				.catch(function (response) {
					return (response && response.data && response.data.error) ? response.data.error : 'Could not rerun data job';
				});
		}

		function markFailed(factoryNdx, jobId) {
			var markFailedUrl = '/api/2/factndx/' + factoryNdx + '/WorkerQueue/Job/' + jobId + '/MarkFailed';
			return $http.put(markFailedUrl)
				.then(function () {
					return '';
				})
				.catch(function (response) {
					return (response && response.data && response.data.error) ? response.data.error : 'Could not mark data job as failed';
				});
		}

		function getAwsLogsGroup(logtype) {
			var env = window.globalConfig.environment.toUpperCase();
			var logsGroup = logtype === 'lc2-cloudwatch-logs' ? '/leandna-connect/status' : 'WORKER-' + env + '-/var/log/' + logtype;
			return logsGroup;
		}

		function getAwsLogsUrl(awsRegion, awsAccountId, instanceId, logType, dateStart, dateEnd, factoryNdx) {
			var env = window.globalConfig.environment.toUpperCase();
			return storeService.dataPipelineUtils.getAwsLogsUrl(
				awsRegion,
				awsAccountId,
				instanceId,
				logType,
				dateStart,
				dateEnd,
				factoryNdx,
				env
			);
		}

		function getAwsLogsCli(awsRegion, instanceId, logType, dateStart, dateEnd, factoryNdx) {
			var cli = 'aws logs';
			
			if (logType === 'lc2-cloudwatch-logs'){
				var filter = '"{($.site_id=' +factoryNdx+ ') && '
					+ '($.command = "start-extract" || $.command = "start-pipeline-job"'
					+ '|| $.command = "start-table-extract" || $.command = "complete-pipeline-job")}"';
				cli += ' filter-log-events --region ' + awsRegion
				 		+ ' --log-group-name "' + getAwsLogsGroup(logType, instanceId) + '"'
				    + ' --filter-pattern '+ filter
						+ ' --start-time ' + dateStart;
				cli += dateEnd ? ' --end-time ' + dateEnd : '';
			} else {
				cli += ' get-log-events --region ' + awsRegion
						+ ' --log-group-name ' + getAwsLogsGroup(logType, instanceId)
				    + ' --log-stream-name ' + instanceId
						+ ' --start-time ' + dateStart;
				cli += dateEnd ? ' --end-time ' + dateEnd : '';
				cli	+= ' --output text --query "events[*].[message]"';
			}
			return cli;
		}

		function getSfnExecutionUrl(awsRegion, executionArn) {
			var href = 'https://'
				+ awsRegion
				+ '.console.aws.amazon.com/states/home?region='
				+ awsRegion
				+ '#/executions/details/'
				+ executionArn;
			return href;
		}

		function getSfnExecutionCli(awsRegion, executionArn) {
			var cli = 'aws stepfunctions describe-execution --region '
				+ awsRegion
				+ ' --execution-arn '
				+ executionArn;
			return cli;
		}

		function getInsightLogsUrl(awsRegion, factoryNdx, jobId, executionArn, executionType) {
			var apiPath = '/WorkerData/StateMachineLambdaLogsUrl';
			if (executionType === 'casm') {
				apiPath = '/WorkerData/CasmLambdaLogsUrl';
			}

			var generateInsightsUrl = '/api/2/factndx/'
				+ factoryNdx
				+ apiPath
				+ '?jobId='
				+ jobId
				+ '&executionArn='
				+ encodeURIComponent(executionArn);
			return $http.get(generateInsightsUrl)
				.then(function (response) {
					return response.data;
				})
				.catch(function (response) {
					return '';
				});
		}
	}
})();
